import { IPropsWithChildren } from '@omaze/app';
import React, { FunctionComponent, ReactElement, Fragment, ReactNode } from 'react';

export function useSlot<TSlot> (children: ReactNode, slotType: TSlot): ReactNode {
    let targetChild: ReactNode = undefined;

    React.Children.forEach(children, (child: ReactNode): void => {
        if (typeof child === 'boolean' || typeof child === 'number' || typeof child === 'string') {
            return;
        }

        if ((child as any)?.type?.ozSlot === slotType) {
            targetChild = child;
        }
    });

    return targetChild;
}

export interface ISlotProps extends IPropsWithChildren {}

export function createLayoutSlot<TSlot> (slotType: TSlot, displayName: string): FunctionComponent {
    function Slot (props: ISlotProps): ReactElement {
        const { children }: ISlotProps = props;

        return <Fragment>{children}</Fragment>;
    }

    Slot.ozSlot = slotType;
    Slot.displayName = displayName;

    return Slot;
}
